import {
    CodeBlock, BlockType, SettingType,
    ValidationMessage, ValidationMessageType, TibboDataType, IOMode,
} from '@appblocks/codegeneration/types';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_04_1 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_04_1';
        this.name = 'Tibbit 04_1';
        this.lines = 2;
        this.mode = IOMode.INPUT;
        this.initLines();
    }
}
